module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAATNJREFUOE/tlD1KA1EUhc95Q0xjJ4YUwcINiAuwsLDQFVgpkkmEgGDtArS1srmDi1BBURtbi8HWRq11A87IvCMjKZ4Tw6Ckkrzu3vP4uNyfQwSv3++fStoJUqmkM5JNkpLUAbAV6M9mthgyGAa9Xk9hDOCe5K2kmRLovW+R3A7/mNk3xk/Au0ajsZllWdM51/Let6Mo8iWE5HtRFE8APpxzS5IuaoGSrpIkWa9UOhJ2u91l51w6BWJkKNMejt2ef7Q2AC7NbGNil0LyEcBJaQgBNJLkS4MY3nQBYEHSfu3p1VVW1f8CfCB5KGkFwN4kgAdmdhTHcYdkCmD+N354DWCtUsUrgONhfrWivZlZa6xjDwaDdp7nuyRLZ/4agKQ5SRHJWUkvzjkvqfSAQtJ5kiQ3IfATKBj/FSaWlAgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/手机.png
// module id = pMXJ
// module chunks = 26